module.exports = __webpack_public_path__ + "img/home_menu_6_selected.d919824a.png";